export type Dimensions = {
  width: number;
  height: number;
};
